export const loreDictionaryKeys = ['Awakened', 'Old Earth'] as const;

export type LoreDictionaryKey = (typeof loreDictionaryKeys)[number];

export const loreDictionary: Record<LoreDictionaryKey, string> = {
  Awakened: 'The moniker used for those that successfully woke after the long sleep.',
  'Old Earth': "Usually preceded with 'good', the good Old Earth was our home before the incident.",
};
